<template>
    <div>
        <div class="row">
            <div class="col-md-9 col-12">
                <nav class="navbar navbar-expand-lg navbar-light bg-light">
                    <b-button
                        variant="primary"
                        @click.prevent="addUser"
                    >
                        <i class="icon ion-md-person-add" /> ユーザー追加
                    </b-button>
                    <div class="mr-auto" />
                    <form
                        class="form-inline"
                        @submit.prevent
                    >
                        <div class="form-group ml-1 my-2 my-sm-0">
                            <b-form-select
                                v-model="selectedTeam"
                                :options="teams2"
                                @change="teamChange"
                            />
                        </div>
                    </form>
                </nav>
                <b-table
                    ref="table"
                    selectable
                    striped
                    hover
                    :items="users"
                    :fields="fields"
                    :current-page="currentPage"
                    primary-key="vid"
                    :per-page="perPage"
                    bordered
                    select-mode="single"
                    show-empty
                    empty-text="結果ありません"
                    @row-selected="rowSelected"
                >
                    <template #cell(id)="data">
                        <div>{{ data.item.username }}</div>
                        <small class="text-info">{{ data.item.last_name }} {{ data.item.first_name }}</small>
                        <b-badge
                            v-if="!data.item.is_active"
                            pill
                            variant="secondary"
                            class="float-right"
                        >
                            無効
                        </b-badge>
                        <b-badge
                            v-if="data.item.is_manager"
                            pill
                            variant="primary"
                            class="float-right"
                        >
                            マネージャー
                        </b-badge>
                    </template>
                    <template #cell(created)="data">
                        <div>{{ $moment(data.value).local().calendar() }}</div>
                        <div class="small text-muted">
                            最後のログイン:<br>{{
                                data.item.last_login ? $moment(data.item.last_login).local().calendar() : 'ログインしたことない'
                            }}
                        </div>
                    </template>
                </b-table>
                <b-row>
                    <b-col
                        md="6"
                        class="my-1"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            class="my-0"
                        />
                    </b-col>
                    <b-col
                        md="6"
                        class="my-1 text-right"
                    >
                        <span>{{ currentRows }} / {{ totalRows }}</span>
                    </b-col>
                </b-row>
            </div>
            <div class="col-md-3 d-none d-md-block">
                <div
                    id="info-card"
                    class="card info-card"
                >
                    <div
                        v-if="selectedItem"
                        class="card-body"
                    >
                        <div class="card-text mb-3 small">
                            <div>
                                <span class="font-weight-bold">UID：</span><span
                                    class="text-info"
                                    v-html="selectedItem.id"
                                />
                            </div>
                            <div>
                                <span class="font-weight-bold">名前：</span><span
                                    class="text-info"
                                    v-html="selectedItem.last_name + ' ' + selectedItem.first_name"
                                />
                            </div>
                            <div>
                                <span class="font-weight-bold">ユーザー名：</span><span
                                    class="text-info"
                                    v-html="selectedItem.username"
                                />
                            </div>
                            <div>
                                <span class="font-weight-bold">チーム：</span><span
                                    class="text-info"
                                    v-html="selectedItem.group"
                                />
                            </div>
                            <div>
                                <span class="font-weight-bold">Eメール：</span><span
                                    class="text-info"
                                    v-html="selectedItem.email"
                                />
                            </div>
                            <div>
                                <span class="font-weight-bold">端末数：</span><span
                                    class="text-info"
                                    v-html="selectedItem.devices?selectedItem.dev:0"
                                />
                                <b-btn
                                    v-if="selectedItem.last_login"
                                    variant="outline-primary"
                                    size="sm"
                                    @click="showDevice"
                                >
                                    端末のリスト
                                </b-btn>
                            </div>
                        </div>
                    </div>
                    <b-button-group
                        v-if="selectedItem"
                        class="no-round"
                    >
                        <b-button
                            variant="warning"
                            @click="editUser"
                        >
                            編集
                        </b-button>
                        <b-button
                            v-if="!selectedItem.deleted"
                            variant="danger"
                            @click="deleteUser"
                        >
                            削除
                        </b-button>
                        <b-button
                            v-if="selectedItem.is_active"
                            variant="secondary"
                            @click="disable"
                        >
                            無効化
                        </b-button>
                        <b-button
                            v-if="!selectedItem.is_active"
                            variant="primary"
                            @click="enable"
                        >
                            有効化
                        </b-button>
                    </b-button-group>
                </div>
            </div>
        </div>
        <b-modal
            id="modalUser"
            ref="userModal"
            :title="form.title"
            size="md"
            cancel-title="キャンセル"
            ok-title="保存"
            @ok.prevent="submitUser"
        >
            <b-form>
                <b-form-row>
                    <b-col>
                        <b-form-group
                            label="氏"
                            label-for="last_name"
                        >
                            <b-form-input
                                id="last_name"
                                v-model="form.last_name"
                                placeholder="氏"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="名"
                            label-for="first_name"
                        >
                            <b-form-input
                                id="first_name"
                                v-model="form.first_name"
                                placeholder="名"
                            />
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <b-form-group
                            label="ユーザー名"
                            label-for="username"
                        >
                            <b-form-input
                                id="username"
                                v-model="form.username"
                                placeholder="ユーザー名"
                                type="email"
                                required
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Eメール"
                            label-for="email"
                        >
                            <b-form-input
                                id="email"
                                v-model="form.email"
                                placeholder="Eメール"
                                type="email"
                            />
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-group
                    label="チーム"
                    label-for="team"
                >
                    <b-form-select
                        id="team"
                        v-model="form.group_id"
                        :options="teams"
                        required
                    />
                </b-form-group>
                <b-form-group
                    label="パスワード"
                    label-for="password"
                    :description="form.new ? '' : '変更がなければ空にしてください'"
                >
                    <b-input-group>
                        <b-form-input
                            id="password"
                            ref="password"
                            v-model="form.password"
                            :required="form.new"
                            placeholder="パスワード"
                        />
                        <b-input-group-append>
                            <b-button
                                variant="outline-success"
                                @click.prevent="copyPass"
                            >
                                <i
                                    class="icon ion-md-copy"
                                />
                            </b-button>
                            <b-button
                                variant="info"
                                @click.prevent="createPass"
                            >
                                <i class="icon ion-md-color-wand" />
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
                <b-form-checkbox
                    v-model="form.is_manager"
                    name="is_manager"
                    value="true"
                    unchecked-value="false"
                >
                    マネージャー
                </b-form-checkbox>
            </b-form>
        </b-modal>
        <b-modal
            id="modalDeviceList"
            ref="deviceModalList"
            title="使用した端末"
            size="lg"
            hide-footer
            @show="deviceModalOpen"
        >
            <div style="max-height: 600px; overflow-y: auto">
                <b-list-group>
                    <b-list-group-item
                        v-for="device in devices"
                        :key="device.device_id"
                    >
                        <i
                            v-if="device.md.tablet()"
                            class="icon ion-md-tablet-portrait"
                        />
                        <i
                            v-else-if="device.md.phone()"
                            class="icon ion-md-phone-portrait"
                        />
                        <i
                            v-else
                            class="icon ion-md-laptop"
                        />
                        <span
                            class="ml-2"
                            :class="{ 'text-muted': !device.active }"
                        >{{ device.agent }}</span><br>
                        <small class="text-warning">{{ device.guid }}</small>&nbsp;
                        <small class="text-info">{{ device.last_ip }}</small>
                        <small class="text-secondary">{{ $moment(device.updated_at).calendar() }}</small>
                        <b-badge
                            v-if="device.md.os()"
                            pill
                            variant="info"
                            class="float-right"
                        >
                            {{ device.md.os() }}
                        </b-badge>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </b-modal>
    </div>
</template>

<script>
import MobileDetect from 'mobile-detect'

export default {
    name: 'Users',
    props: {
        teams: Array,
        teams2: Array
    },
    data () {
        return {
            form: {},
            devices: [],
            selectedItem: null,
            selectedTeam: null,
            totalRows: 0,
            currentPage: 1,
            perPage: 50,
            currentRows: '',
            fields: [
                {
                    key: 'id',
                    label: 'ユーザ－'
                },
                {
                    key: 'created',
                    label: '作成日付',
                    thClass: 'date'
                },
                {
                    key: 'group',
                    label: 'チーム',
                    thClass: 'group'
                }
            ]
        }
    },
    mounted () {
        this.$root.$on('updateTable', () => {
            if (this.$refs.table) {
                this.$refs.table.refresh()
            }
        })
    },
    methods: {
        createPass () {
            const s = [...Array(10)].map(() => (~~(Math.random() * 36)).toString(36)).join('')
            console.log(s)
            this.form.password = s
            this.$refs.password.$el.value = s
        },
        copyPass () {
            this.$refs.password.select()
            document.execCommand('copy')
        },
        addUser () {
            this.form = {
                new: true,
                title: 'ユーザー追加',
                id: 0
            }
            this.$refs.userModal.show()
        },
        submitUser () {
            if (this.form.new && !this.form.group_id) {
                return
            }
            if (this.form.new && !this.form.password) {
                return
            }
            this.$http.post('user/' + this.form.id, {
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                username: this.form.username,
                email: this.form.email,
                group_id: this.form.group_id,
                is_manager: this.form.is_manager,
                password: this.form.password
            }).then((r) => {
                if (r) {
                    this.$refs.userModal.hide()
                    this.$refs.table.refresh()
                }
            }).catch((error) => {
                if (error.response) {
                    switch (error.response.status) {
                    default:
                        if (error.response.data && error.response.data.error) {
                            this.$snotify.error(error.response.data.error)
                        } else {
                            this.$snotify.error('サーバーエラー')
                        }
                        break
                    }
                }
            })
        },
        deviceModalOpen () {
            this.devices = []
            if (this.selectedItem && this.selectedItem.devices) {
                this.selectedItem.devices.forEach(value => {
                    value.md = new MobileDetect(value.agent)
                    this.devices.push(value)
                })
            }
        },
        showDevice () {
            this.$refs.deviceModalList.show()
        },
        disable () {
            this.$swal({
                title: 'ユーザーを無効化',
                text: `「${this.selectedItem.first_name} ${this.selectedItem.last_name}」を無効化しますか？`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'キャンセル',
                confirmButtonText: '無効化'
            }).then((result) => {
                if (result.value) {
                    const $this = this
                    this.$root.$emit('loading', true)
                    this.$http.post('user/' + this.selectedItem.id + '?oper=disable').then((response) => {
                        this.$root.$emit('loading', false)
                        if (response) {
                            this.$refs.table.refresh()
                        }
                    }).catch(function (error) {
                        $this.$root.$emit('loading', false)
                        if (error.response) {
                            switch (error.response.status) {
                            case 404:
                                $this.$snotify.error('指定したユーザーが存在しない')
                                break
                            case 403:
                                $this.$snotify.error('操作の権限がありません')
                                break
                            default:
                                if (error.response.data && error.response.data.error) {
                                    $this.$snotify.error(error.response.data.error)
                                } else {
                                    $this.$snotify.error('サーバーエラー')
                                }
                                break
                            }
                        }
                    })
                }
            })
        },
        enable () {
            this.$swal({
                title: 'ユーザーを有効化',
                text: `「${this.selectedItem.first_name} ${this.selectedItem.last_name}」を有効化しますか？`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'キャンセル',
                confirmButtonText: '有効化'
            }).then((result) => {
                if (result.value) {
                    const $this = this
                    this.$root.$emit('loading', true)
                    this.$http.post('user/' + this.selectedItem.id + '?oper=enable').then((response) => {
                        this.$root.$emit('loading', false)
                        if (response) {
                            this.$refs.table.refresh()
                        }
                    }).catch(function (error) {
                        $this.$root.$emit('loading', false)
                        if (error.response) {
                            switch (error.response.status) {
                            case 404:
                                $this.$snotify.error('指定したユーザーが存在しない')
                                break
                            case 403:
                                $this.$snotify.error('操作の権限がありません')
                                break
                            default:
                                if (error.response.data && error.response.data.error) {
                                    $this.$snotify.error(error.response.data.error)
                                } else {
                                    $this.$snotify.error('サーバーエラー')
                                }
                                break
                            }
                        }
                    })
                }
            })
        },
        deleteUser () {
            // TODO
        },
        editUser () {
            this.form = this.selectedItem
            this.form.title = 'ユーザー編集'
            this.$refs.userModal.show()
        },
        rowSelected (item) {
            if (item.length) {
                this.selectedItem = item[0]
                this.$http.get('user/' + this.selectedItem.id).then((r) => {
                    if (r) {
                        this.selectedItem = r.data.user
                        let dev = 0
                        if (r.data.devices.length) {
                            const a = r.data.devices.filter(value => value.active).length
                            dev = r.data.devices.length + ' total (' + a + ' active)'
                        }
                        this.selectedItem.devices = r.data.devices
                        this.selectedItem.dev = dev
                    }
                }).catch((error) => {
                    if (error.response) {
                        switch (error.response.status) {
                        default:
                            if (error.response.data && error.response.data.error) {
                                this.$snotify.error(error.response.data.error)
                            } else {
                                this.$snotify.error('サーバーエラー')
                            }
                            break
                        }
                    }
                })
            } else {
                this.selectedItem = null
            }
        },
        teamChange () {
            this.currentPage = 1
            this.$refs.table.refresh()
        },
        users (ctx, cb) {
            const params = '?page=' + ctx.currentPage + '&size=' + ctx.perPage + '&gid=' +
                (this.selectedTeam ? this.selectedTeam : '')
            ctx.busy = true
            this.$http.get('user/list' + params).then((response) => {
                ctx.busy = false
                this.totalRows = response.data.total
                cb(response.data.users)
                let first = 0
                if (response.data.users.length > 0) {
                    first = ((ctx.currentPage - 1) * ctx.perPage) + 1
                    first = first + ' - ' + (first + response.data.users.length - 1)
                } else {
                    if (this.keyword || this.shot_date) {
                        this.$snotify.warning('結果がありません')
                    }
                }
                this.currentRows = first
            }).catch((error) => {
                ctx.busy = false
                if (error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.$snotify.error(error.response.data.error)
                    } else {
                        this.$snotify.error('サーバーエラー')
                    }
                }
                cb([])
                console.log(error)
            })
        }
    }
}
</script>

<style scoped>
.no-round .btn {
    border-radius: 0;
}

#info-card {
    min-height: 300px;
    position: -webkit-sticky;
    position: sticky;
    top: 70px;
}
</style>
